import { useMemo } from "react";
import { useUserStatus } from "./useUserStatus";
import { useActiveWorkspaceDetails } from "./useActiveWorkspaceDetails";

export function useCurrentUserIsWorkspaceOrganizationMember(): {
    isOrganizationMember: boolean;
    isFetched: boolean;
} {
    const workspaceDetails = useActiveWorkspaceDetails();
    const { data: userStatus } = useUserStatus();

    const currentUser = userStatus?.user;

    const isOrganizationMember = useMemo(() => {
        if (!workspaceDetails || !currentUser) {
            return false;
        }

        const organizationIds = new Set(
            workspaceDetails.organizationAssignments.map(
                ({ organizationId }) => organizationId,
            ),
        );

        return workspaceDetails.assignments.some(
            ({ user, organizationId }) =>
                user.id === currentUser.id &&
                organizationId !== null &&
                organizationIds.has(organizationId),
        );
    }, [currentUser, workspaceDetails]);

    return {
        isOrganizationMember,
        isFetched: workspaceDetails !== undefined && !!userStatus,
    };
}
